import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  AddonServiceRuleItemsData,
  LastMinuteRuleDetails,
  MinimumLengthOfStayRuleDetails,
  PreparationRestrictionRuleDetails,
  PriceChangeRuleDetails,
  ReleaseIntervalRuleDetails,
  ShortStayRuleDetails,
  WeekdayCheckInAndCheckOutTimeItemsData,
  WeekdayCheckInRuleItem,
  WeekdayCheckOutRuleItem,
  WeekdayMinimumStayRuleItemsData,
  WeekdayPriceChangeRuleItemsData,
} from '../types/rates.types';
import axiosInstance from './axiosInstance';

export function fetchWeekdayCheckInRulesBySeasonRateId(seasonRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rateRules/getWeekdayCheckInRulesBySeasonRateId', config)
    .then(res => res.data);
}

export function fetchWeekdayCheckOutRulesBySeasonRateId(seasonRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rateRules/getWeekdayCheckOutRulesBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRateWeekdayCheckInAndCheckOutRules(
  seasonRateId: string,
  weekdayCheckInRuleData: WeekdayCheckInRuleItem[],
  weekdayCheckOutRuleData: WeekdayCheckOutRuleItem[],
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  const requestData = {
    seasonRateId,
    blockedCheckInWeekdays: weekdayCheckInRuleData,
    blockedCheckOutWeekdays: weekdayCheckOutRuleData,
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateWeekdayCheckInAndCheckOutRules',
      requestData,
      config,
    )
    .then(res => res.data);
}

export function fetchMinimumLengthOfStayRuleBySeasonRateId(
  seasonRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rateRules/getMinimumLengthOfStayRuleBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRateMinimumLengthOfStayRule(
  minimumLengthOfStayRuleData: MinimumLengthOfStayRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateMinimumLengthOfStayRule',
      minimumLengthOfStayRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchPreparationRestrictionRuleBySeasonRateId(
  seasonRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get(
      '/pricing/rateRules/getPreparationRestrictionRuleBySeasonRateId',
      config,
    )
    .then(res => res.data);
}

export function updateSeasonRatePreparationRestrictionRule(
  preparationRestrictionRuleData: PreparationRestrictionRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRatePreparationRestrictionRule',
      preparationRestrictionRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchShortStayRuleBySeasonRateId(seasonRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rateRules/getShortStayRuleBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRateShortStayRule(
  shortStayRuleData: ShortStayRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateShortStayRule',
      shortStayRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchLastMinuteRuleBySeasonRateId(seasonRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rateRules/getLastMinuteRuleBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRateLastMinuteRule(
  lastMinuteRuleData: LastMinuteRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateLastMinuteRule',
      lastMinuteRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchPriceChangeRuleBySeasonRateId(seasonRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rateRules/getPriceChangeRuleBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRatePriceChangeRule(
  priceChangeRuleData: PriceChangeRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRatePriceChangeRule',
      priceChangeRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchWeekdayMinimumStayRulesDataBySeasonRateId(
  seasonRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rateRules/getWeekdayMinimumStayRulesBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRateWeekdayMinimumStayRulesData(
  weekdayMinimumStayRuleData: WeekdayMinimumStayRuleItemsData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateWeekdayMinimumStayRules',
      weekdayMinimumStayRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchWeekdayPriceChangeRulesDataBySeasonRateId(
  seasonRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rateRules/getWeekdayPriceChangeRulesBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRateWeekdayPriceChangeRulesData(
  weekdayPriceChangeRuleData: WeekdayPriceChangeRuleItemsData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateWeekdayPriceChangeRules',
      weekdayPriceChangeRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchWeekdayCheckInAndCheckOutTimesDataBySeasonRateId(
  seasonRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get(
      '/pricing/rateRules/getWeekdayCheckInCheckOutTimesBySeasonRateId',
      config,
    )
    .then(res => res.data);
}

export function updateSeasonRateWeekdayCheckInAndCheckOutTimesData(
  weekdayCheckInAndCheckOutTimesData: WeekdayCheckInAndCheckOutTimeItemsData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateWeekdayCheckInCheckOutTimes',
      weekdayCheckInAndCheckOutTimesData,
      config,
    )
    .then(res => res.data);
}

export function fetchReleaseIntervalRuleBySeasonRateId(seasonRateId: string) {
  const config = {
    params: { seasonRateId },
  };

  return axiosInstance
    .get('/pricing/rateRules/getReleaseIntervalRuleBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRateReleaseIntervalRule(
  releaseIntervalRuleData: ReleaseIntervalRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateReleaseIntervalRule',
      releaseIntervalRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchAdditionalServiceRulesData(
  seasonRateId: string,
  accommodationId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId, accommodationId },
  };

  return axios
    .get('/pricing/rateRules/getAdditionalServiceRulesBySeasonRateId', config)
    .then(res => res.data);
}

export function updateSeasonRateAdditionalServiceRules(
  addonServiceRuleItemsData: AddonServiceRuleItemsData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateSeasonRateAdditionalServiceRule',
      addonServiceRuleItemsData,
      config,
    )
    .then(res => res.data);
}

export function deleteSeasonRateRule(ruleId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { ruleId },
  };

  return axios
    .delete('/pricing/rateRules/deleteSeasonRateRule', config)
    .then(res => res.data);
}

export function deleteSeasonRateRuleReleaseInterval(ruleId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { ruleId },
  };

  return axios
    .delete(
      '/pricing/rateRules/deleteSeasonRateRateRuleReleaseInterval',
      config,
    )
    .then(res => res.data);
}
